import { create } from "zustand";
import {
  activeStatus,
  allContent,
  allSegment,
  manageComponents,
  oneComponentDetail,
  putEditComponent,
  search,
  viewTypeData,
} from "../api_layer/api";

export const useComponentStore = create((set) => ({
  componentData: [],
  segData: [],
  contData: [],
  oneComponentData: [],
  viewData: [],
  contViewData: [],
  componentLoading: false,
  segmentLoading: false,
  contentLoading: false,
  oneComponentLoading: false,
  viewLoading: false,
  contViewLoading: false,
  statusLoading: false,
  error: null,
  fetchComponentData: async (page, keyword, active) => {
    try {
      set({ componentLoading: true, error: null });
      const response = await manageComponents(page, keyword, active);
      set({ componentData: response.data, componentLoading: false });
    } catch (error) {
      set({ error: error.message, componentLoading: false });
    }
  },
  fetchAllSegment: async () => {
    try {
      set({ segmentLoading: true, error: null });
      const response = await allSegment();
      set({ segData: response.data, segmentLoading: false });
    } catch (error) {
      set({ error: error.message, segmentLoading: false });
    }
  },
  fetchAllContent: async () => {
    try {
      set({ contentLoading: true, error: null });
      const response = await allContent();
      set({ contData: response.data, contentLoading: false });
    } catch (error) {
      set({ error: error.message, contentLoading: false });
    }
  },
  fetchComponentDetail: async (id) => {
    try {
      set({ oneComponentLoading: true, error: null });
      const response = await oneComponentDetail(id);
      set({ oneComponentData: response.data, oneComponentLoading: false });
    } catch (error) {
      set({ error: error.message, oneComponentLoading: false });
    }
  },
  fetchView: async (id, type) => {
    try {
      set({ viewLoading: true, error: null });
      const response = await viewTypeData(id, type);
      set({ viewData: response.data, viewLoading: false });
    } catch (error) {
      set({ error: error.message, viewLoading: false });
    }
  },
  updateActiveStatus: async (
    id,
    status,
    setToaster,
    fetchComponentData,
    searchText
  ) => {
    try {
      set({ activeLoading: true, error: null });
      const response = await activeStatus(id, status);
      set({ activeData: response.data, activeLoading: false });
      setToaster("Status", "Status has been changed", "success");
      if (searchText) {
        const keyword = `keyword=${searchText}&`;
        fetchComponentData(0, keyword);
      } else {
        fetchComponentData(0, "");
      }
    } catch (error) {
      setToaster("Status", "Status not updated", "danger");
      set({ error: error.message, activeLoading: false });
    }
  },
  postEditComponent: async (
    id,
    payload,
    setToaster,
    fetchComponentData,
    searchText,
    setModalShow
  ) => {
    try {
      set({ postEditLoading: true, error: null });
      const response = await putEditComponent(id, payload);
      setToaster("Component", "Component saved successfully", "success");
      if (searchText) {
        const keyword = `keyword=${searchText}&`;
        fetchComponentData(0, keyword);
      } else {
        fetchComponentData(0, "");
      }
      setModalShow(false);
      set({ postEditLoading: false });
    } catch (error) {
      setToaster("Component", "Component Update failed", "danger");
      set({ error: error.message, postEditLoading: false });
    }
  },
}));
